import { CurrencyPipe } from '@angular/common';

export const getCurrencySymbol = (pipe: CurrencyPipe) => {
  return pipe.transform(1)?.replace(/[\d\s,\.]/g, '') || '';
};
